import { Outlet } from 'react-router';

import { useIsMobile } from '@common/hooks';
import Footer from '@components/Footer';
import Header from '@components/Header';

import { useLayoutConfig } from './helpers';

import style from './styles.module.scss';

const BaseLayout = () => {
  const isMobile = useIsMobile();
  const { showHeader, showFooter } = useLayoutConfig();

  return (
    <div className={style.main}>
      {showHeader && <Header />}

      <div className={style.report}>
        <Outlet />
      </div>

      {!isMobile && showFooter && <Footer />}
    </div>
  );
};

export default BaseLayout;
